<template>
    <v-container style="padding: 0 10%">
        <vueHeadful
        :title="this.$i18n.t('Menu.AdministracionPagos') + ' - TrArtist'"
        :url="'https://trartist.com' + $route.fullPath"
        />
        <v-row>
            <v-col cols="12">
              <v-text-field solo v-model="buscar" :label="$t('Busqueda.Buscar')"></v-text-field>
                <v-data-table
                  :headers="headers"
                  :items="pedidos"
                  :search="buscar">
                <template v-slot:[`item.ver`]="{ item }" justify="center">
                    <v-icon @click="subirComprobante(item)" color="black">fa fa-upload</v-icon>
                    <v-btn icon :href="item.comprobantePago" target="_blank"><v-icon color="black">far fa-eye</v-icon></v-btn>
                </template>
                </v-data-table>
                <v-dialog v-model="dialog">
                  <v-card v-if="comprobante">
                    <v-card-title>
                      <v-container>
                        <v-row justify="center">
                            <v-col cols="12" align="center" class="my-5">
                              <h2>{{$t('Pagos.ComprobantePago')}}</h2>
                              <br>
                              <h3>{{comprobante.uid}}</h3>
                              <br>
                              <span>{{comprobante.fecha}}</span>
                            </v-col>
                             <v-col cols="12" md="8" align="center" class="my-5">
                              <em><b><p style="word-break:break-word;">{{$t('Pagos.SeleccionComprobante')}}</p></b></em>
                              <v-file-input class="mt-5" :rules="requerido" solo v-model="comprobantePago" :label="$t('Pagos.AdjuntarComprobante')" :hint="$t('Pagos.AdjuntarComprobante')" :loading="getCargandoAccion" />
                             </v-col>
                             <v-col cols="12" align="center">
                               <v-btn  v-if="comprobantePago" class="ma-3" outlined color="primary" x-large style="border: 2px solid" @click="subirComprobantePago()">{{$t('Formularios.Actualizar')}}</v-btn>
                                <v-btn class="ma-3" outlined color="primary" x-large style="border: 2px solid" @click="dialog = false">{{$t('Formularios.Cerrar')}}</v-btn>
                             </v-col>
                        </v-row>
                      </v-container>
                    </v-card-title>
                  </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapMutations, mapActions, mapGetters } from 'vuex'
export default {
  name: 'AdministracionContratos',
  data () {
    return {
      buscar: null,
      pedidos: [],
      dialog: false,
      elegido: null,
      indexElegido: null,
      comentario: null,
      contratos: [],
      certificados: [],
      comprobante: null,
      comprobantePago: null,
      requerido: [v => !!v || this.$i18n.t('Formularios.CampoRequerido')],
      headers: [
        { text: this.$i18n.t('Pagos.Categoria'), value: 'producto.categoria' },
        { text: this.$i18n.t('Pagos.Nombre'), value: 'artista.nombre' },
        { text: this.$i18n.t('Pagos.Codigo'), value: 'uidPago' },
        { text: this.$i18n.t('Pagos.Fecha'), value: 'fecha' },
        { text: this.$i18n.t('Pagos.Referencia'), value: 'producto.referencia' },
        { text: this.$i18n.t('Pagos.ValorVenta'), value: 'total' },
        { text: this.$i18n.t('Pagos.ValorPago'), value: 'producto.totalArtista' },
        { text: this.$i18n.t('Pagos.Comprobante'), value: 'ver' }
      ]
    }
  },
  computed: {
    ...mapGetters(['getCargandoAccion'])
  },
  methods: {
    subirComprobante (item) {
      this.comprobante = item
      this.dialog = true
      this.comprobantePago = null
      // console.log(this.comprobante)
    },
    async subirComprobantePago () {
      this.pedidos = []
      this.setCargandoAccion(true)
      this.subirCertificado().then(url => {
        firebase.firestore().collection('comprobante_pago').doc(this.comprobante.uid).set({
          uid: this.comprobante.uid,
          uidProducto: this.comprobante.producto.uid,
          uidComprador: this.comprobante.comprador.uid,
          uidArtista: this.comprobante.artista.uid,
          nombre: this.comprobante.producto.titulo,
          comprador: this.comprobante.comprador.nombre,
          compradorEmail: this.comprobante.comprador.email,
          compradorDocumento: this.comprobante.comprador.documento,
          fecha: new Date().toISOString().slice(0, 10),
          estado: 'pago',
          valor: this.comprobante.producto.totalArtista,
          urlComprobante_pago: url
        })
          .then(() => {
            firebase.firestore().collection('pedidos').doc(this.comprobante.uid).update({
              comprobantePago: url
            }).then(() => {
              this.enviarCorreoAdjunto({
                // email: 'danielzemanate@gmail.com',
                // asunto: this.$i18n.t('Email.AsuntoPagos',{ titulo: this.pedidoElegido.producto.titulo, uid: this.comprobante.producto.uid }),
                // texto: this.$i18n.t('Email.AsuntoTextoPagos', {
                //   nombre: this.comprobante.artista.nombre,
                //   titulo: this.comprobante.producto.titulo,
                //   uid: this.comprobante.producto.uid
                // }),
                email: 'TrArtist <soycliente@trartist.com>',
                destino: this.comprobante.artista.email,
                asunto: `Tu producto ${this.comprobante.producto.titulo} de referencia ${this.comprobante.producto.uid} ha sido pago`,
                texto: `<span>Hola ${this.comprobante.artista.nombre}</span><br><br>
                <span>Se ha realizado el pago del producto ${this.comprobante.producto.titulo} de referencia ${this.comprobante.producto.uid} puede verificarlo en su backOffice en su perfil de TrArtis, además se adjunta archivo pdf con comprobante de pago</span>
                <br><br>
                    <span>Un saludo,</span>
                    <br>
                    <span><b>Equipo TrArtist</b></span>
                    <br>
                    <img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>`,
                filename: 'comprobantePago.pdf',
                path: this.comprobante.comprobantePago
              })
            }).then(() => {
              firebase.firestore().collection('pedidos').get().then(info => {
                for (let i = 0; i < info.docs.length; i++) {
                  this.pedidos.push(info.docs[i].data())
                }
              })
            }).then(() => {
              this.setAlerta()
              this.setTextoAlerta('Alerta.InformacionActualizada')
              this.setCargandoAccion(false)
            })
          })
      })
      // console.log(this.comprobante)
    },
    async subirCertificado () {
      var upload = await firebase.storage().ref().child('comprobante_pago/' + this.comprobante.uid).put(this.comprobantePago)
      var url = await upload.ref.getDownloadURL()
      return url
    },
    ...mapMutations(['setAlerta', 'setTextoAlerta', 'setCargandoAccion']),
    ...mapActions(['enviarCorreo'])
  },
  mounted () {
    firebase.firestore().collection('pedidos').get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.pedidos.push(info.docs[i].data())
      }
    })
  }
}
</script>
